<template>
  <div>
    <section class="xbed-sub-title">
      <span>手工入账导入记录</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>报表</BreadcrumbItem>
        <BreadcrumbItem>结算账单报表</BreadcrumbItem>
        <BreadcrumbItem>手工入账导入记录</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <br>
    <Form inline @submit.native.prevent='preventSubmit'>
      <FormItem label='导入日期：' :label-width='100'>
        <DatePicker type='daterange' v-model="creatTime" :options="accountDateOptions" :start-date='nowDate' placeholder="请选择使时间" class="date-time" style="width: 230px"></DatePicker>
      </FormItem>
      <FormItem>
        <Button type='primary' @click='queryKeyWords'>查询</Button>
      </FormItem>
    </Form>
    <Content>
      <Table :columns='recordColumns' :data='dataList' style="width: 1470px;"></Table>
      <div style="marginTop:10px;">
        <Page :total="listTotal" show-sizer :current='page' :page-size='pageSize' @on-change='changePage' @on-page-size-change='changePageSize'></Page>
      </div>
    </Content>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api"

export default {
   async created() {
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.headerENV = Utils.aliHeaderEnv(this.env)
	},
  data () {
    return {
      nowDate:Moment(new Date()-86400000 * 30)._d,
      creatTime:[
        Moment().subtract( 60, 'day' ).format( "YYYY-MM-DD" ),
				Moment().format( 'YYYY-MM-DD' )
      ],
      dataList:[],
      listTotal:0,
      page:1,
      pageSize:10,
      recordColumns:[
        {
          title:'类型',
          key:'type',
          align:'center',
          width:150,
          render:(h,params) => {
            return h('div', {}, params.row.type === 1 ? '手工入账' : '-')
          }
        },
        {
          title:'导入文件名',
          key:'fileName',
          align:'center',
          width:250,
        },
        {
          title:'处理状态',
          key:'status',
          align:'center',
          width:125,
          render:(h,params)=>{
            let status = ['处理中','已完成','处理失败'][params.row.status]
            return h('div',{},status)
          }
        },
        {
          title:'导入数据量',
          key:'importNum',
          align:'center',
          width:130,
          render:(h,params)=>{
            return h('div',{}, params.row.importNum ? params.row.importNum : '-')
          }
        },
        {
          title:'成功数据量',
          key:'successNum',
          align:'center',
          width:130,
          render:(h,params)=>{
            return h('div',{}, params.row.successNum ? params.row.successNum : '-')
          }
        },
        {
          title:'失败数据量',
          key:'failNum',
          align:'center',
          width:130,
          render:(h,params)=>{
            return h('div',{}, params.row.failNum ? params.row.failNum : '-')
          }
        },
        {
          title:'导入时间',
          key:'ctime',
          align:'center',
          width:200,
          render:(h,params)=>{
            let time = params.row.ctime ? Moment(params.row.ctime).format('YYYY-MM-DD'):'-'
            return h('div',{},time)
          }
        },
        {
          title:'操作人',
          key:'creator',
          align:'center',
          width:150,
          render:(h,params)=>{
            return h('div',{}, params.row.creator ? params.row.creator : '-')
          }
        },
        {
          title:'下载',
          key:'downloadUrl',
          align:'center',
          width:200,
          render:(h,params)=>{
            if (params.row.status != 0) {
              return h('Button', {
                props:{
                  type:"primary",
                  loading: params.row.$isLoading
                },
                on:{
                  click:()=>{
                    window.open(params.row.downloadUrl)
                  }
                }
              },'下载导入结果')
            } else {
              return h("span", {}, "-")
            }
          }
        }
      ],
      // 只能选择历史日期
      accountDateOptions: {
        disabledDate (current) {
          return current && current.valueOf() > Date.now()
        }
      }
    }
  },
  mounted () {
    this.$Notice.config( {
			top: 150
    });
    if ( !Utils.hasPermission( 'importRecord_list' ) ) {
      this.$Notice.error( {
        title: "无权限操作"
      } );
      return
    }
    this.queryimportList()
  },
  methods: {
    async queryimportList(){
      let params = {
        page:this.page,
        size:this.pageSize,
        beginDate:this.creatTime[0] ? Moment(this.creatTime[0]).format("YYYY-MM-DD"):'',
        endDate:this.creatTime[1] ? Moment(this.creatTime[1]).format("YYYY-MM-DD"):'',
      }
      const resp = (await API.omsAPI[this.env].clientServer.getImportRecordList(params,{'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg,
					desc: "获取列表数据失败"
				});
      }
      this.dataList = resp.list || []
      this.listTotal = resp.total
    },
    // 查询
    queryKeyWords(){
      this.page = 1
      this.queryimportList()
    },
    changePage(page){
      this.page = page
      this.queryimportList()
    },
    changePageSize(pageSize){
      this.page = 1
      this.pageSize = pageSize
      this.queryimportList()
    },
    preventSubmit(){
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/report/bill-statement/manualRecord.vue